import { Component } from '@angular/core';
import { BaseMediaSourcePanel } from '../basemediasource.panel';
import { MediaPanelInfo } from '../../../../../models/datamodel/mediasource.model';

@Component({
    selector: 'gafileshare-panel',
    templateUrl: './gafileshare.panel.html'
})
export class GAFileSharePanel extends BaseMediaSourcePanel {
    static GetInfo(): MediaPanelInfo {
        return {
            ControlType: GAFileSharePanel,
            MediaType: '87713991-8557-476c-8923-5fdbc4026242'
        };
    }
}
